import React from 'react';
import { Calendar, CheckCircle, Users } from 'lucide-react';
import { Button } from './ui/button';
import { Badge } from './ui/badge';
import { Card, CardContent, CardFooter } from './ui/card';

const ProductCard = ({ product }) => {
  return (
    <Card className="group overflow-hidden hover:shadow-2xl transition-all duration-300 border-gray-300 bg-gradient-to-br from-white via-gray-50 to-gray-150 shadow-lg">
      <div className="relative overflow-hidden aspect-square bg-gradient-to-br from-gray-100 via-white to-gray-100">
        <img
          src={product.image}
          alt={product.name}
          className={`w-full h-full object-contain transition-transform duration-500 ${product.imageScale ? '' : 'p-4 transform group-hover:scale-105'}`}
          style={product.imageScale ? { transform: `scale(${product.imageScale})`, transformOrigin: 'center center' } : undefined}
        />
        {product.inStock && (
          <Badge className="absolute top-3 right-3 bg-emerald-600 hover:bg-emerald-700 text-white border-0 text-xs shadow-md">
            <CheckCircle className="w-3 h-3 mr-1" />
            Available
          </Badge>
        )}
        <div className="absolute inset-0 bg-gradient-to-t from-slate-900/40 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
        <div className="absolute bottom-3 left-3 right-3 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <Badge variant="outline" className="bg-white/95 text-slate-700 border-0 text-xs shadow-md">
            <Users className="w-3 h-3 mr-1" />
            {product.capacity} capacity
          </Badge>
        </div>
      </div>
      
      <CardContent className="p-5 bg-gradient-to-b from-white to-gray-100">
        <Badge variant="outline" className="mb-2 text-xs font-medium border-gray-300 text-slate-600 bg-gray-100">
          {product.subcategory}
        </Badge>
        <h3 className="font-bold text-base text-slate-800 mb-2 line-clamp-1 heading-font">
          {product.name}
        </h3>
        <p className="text-sm text-slate-500 mb-3 line-clamp-2 leading-relaxed">
          {product.description}
        </p>
        {product.category === 'Pequod Acoustics' ? (
          <>
            <div className="flex items-baseline gap-2 mb-1">
              <span className="text-xs text-slate-400">From</span>
              <span className="text-xl font-bold text-slate-800">£{product.dailyRate}</span>
              <span className="text-xs text-slate-400">/ day</span>
            </div>
            <p className="text-xs text-slate-400">Full systems designed and quoted per event</p>
          </>
        ) : (
          <>
            <div className="flex items-baseline gap-2 mb-1">
              <span className="text-xs text-slate-400">From</span>
              <span className="text-xl font-bold text-slate-800">£{product.dailyRate}</span>
              <span className="text-xs text-slate-400">/ day</span>
            </div>
            <div className="text-sm text-slate-400 mb-1">
              <span className="font-medium">£{product.weeklyRate}</span> / week
            </div>
            <p className="text-xs text-slate-400">Prices exclude VAT at 20%</p>
          </>
        )}
      </CardContent>
      
      <CardFooter className="p-5 pt-0 bg-gradient-to-b from-gray-100 to-gray-150">
        <Button className="w-full bg-slate-800 hover:bg-slate-700 text-white transition-all duration-300 shadow-md hover:shadow-lg">
          <Calendar className="w-4 h-4 mr-2" />
          Request Hire
        </Button>
      </CardFooter>
    </Card>
  );
};

export default ProductCard;
